import { useMedplum } from '@medplum/react'
import { useQuery } from '@tanstack/react-query'
import { fetchAllOrganizations } from 'components/Clinical/Providers/fetchAllOrganizations'
import { BaseOrganizationFragment } from 'generated/graphql'
import { QueryKeys } from 'utils/query.constants'

export interface OrganizationList {
  orgList: BaseOrganizationFragment[] | undefined
  orgListIsLoading: boolean
  orgListError: string | null
}

const useOrganizationList = (): OrganizationList => {
  const medplum = useMedplum()

  const {
    data: orgList,
    isLoading: orgListIsLoading,
    error
  } = useQuery({
    queryKey: [QueryKeys.ORGANIZATIONS],
    queryFn: async (): Promise<BaseOrganizationFragment[]> => fetchAllOrganizations(medplum)
  })

  return {
    orgList,
    orgListIsLoading,
    orgListError: error ? error.message : null
  }
}

export default useOrganizationList
